import type { GetCommentAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import { GetCommentAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetCommentAuditByIdArgs = {
  id: string;
};

export const useGetCommentAuditById = createQueryHook<
  UseGetCommentAuditByIdArgs,
  GetCommentAuditByIdResponseRow[],
  AuditLogQueryResult<'comment_audit', GetCommentAuditByIdResponseRow>
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getCommentAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ comment_audit: data }),
  graphqlDocument: GetCommentAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
